






































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { vxm } from '../../store.vuex';
import {
  MULTIPLE_CHOICE,
  PARAGRAPH,
  RADIO_BUTTON,
  SHORT_TEXT,
  DROPDOWN,
  DATE_PICKER,
  CHECK_BOX,
  FIXED_DISPLAY_TEXT,
} from '../../models/jobs/CustomFieldType';
import Datepicker from 'vuejs-datepicker';
import {en, de, es, fr} from 'vuejs-datepicker/dist/locale';

@Component({
  components: {
    Datepicker,
  },
})
export default class GenericCustomFields extends Vue {
  $moment: any;
  @Prop() customFieldsModel;
  @Prop() jobHistoryCustomData;
  @Prop() mode;
  @Prop() errors;
  @Prop () isRequiredStep;
  @Prop () minimumEntries;
  MULTIPLE_CHOICE = MULTIPLE_CHOICE;
  PARAGRAPH = PARAGRAPH;
  RADIO_BUTTON = RADIO_BUTTON;
  SHORT_TEXT = SHORT_TEXT;
  DROPDOWN = DROPDOWN;
  DATE_PICKER = DATE_PICKER;
  CHECK_BOX = CHECK_BOX;
  FIXED_DISPLAY_TEXT = FIXED_DISPLAY_TEXT;

  private dropdownArr: String[] = [];
  private isfixedDisplayIndex = -1;
  private requiredFields:any[]=[]
  
  get getLanguage() {
    const lang = vxm.users.getUserLang || 'en';
    return {en, de, es, fr}[lang];
  }
  
  fetchValues(field) {
    let label = field.name
    if (this.customFieldsModel[label] == 'Let me type') {
     let value = this.customFieldsModel[label+"letMeType"]
     if(value == "1"){
      return 1
      }
     return 0
    }
    return this.customFieldsModel[label]
  }
  get classObject() {
    return {
      'justify-content-center': this.$route.name === 'GuidedSignup',
    };
  }

  get value() {
    return false;
  }
  get additionalSupportRequired() {
    return vxm.users.myUserProfile.additionalSupportRequired;
  }
  get checkedValue() {
    return this.customFieldsModel;
  }

  getLocalDateTime(value) {
    return vxm.utility.convertUTCToLocalTime(value);
  }

  disabledDates(values) {
    if (values.includes('Past') && values.includes('Today')) {
      return { from: new Date(Date.now()) };
    }
    return undefined;
  }

  onDateSelect(date, fieldName) {
    this.customFieldsModel[fieldName] = vxm.utility.convertLocalTimeToUTC(date);
  }

  get getCompanyDateFormat() {
    return vxm.jobs.getCompanyDateFormat;
  }

  checkRadio(field) {
    return field.type === RADIO_BUTTON &&
      vxm.jobs.UserJobHistoryListResponse.profiles
      ? 'radioCSs'
      : 'else_class';
  }
  fixLetMeType() {
    for (var i = 0; i < this.jobHistoryCustomData.length; i++) {
     let label= this.jobHistoryCustomData[i].name
      let value=this.customFieldsModel[label]
      if(value.toLowerCase() == "let me type"){
        this.customFieldsModel[label]  =this.customFieldsModel[label+"letMeType"]
      }
    }
  }
  mounted() {
    this.allRequiredFieldsAnswered()
    this.checkIfAnswered()
    this.fixLetMeType()
    for (var i = 0; i < this.jobHistoryCustomData.length; i++) {
  
      if (this.jobHistoryCustomData[i].type === FIXED_DISPLAY_TEXT) {
        this.isfixedDisplayIndex = i;
        return;
      }
    }


  }
  allRequiredFieldsAnswered() {
    for (var i = 0; i < this.jobHistoryCustomData.length; i++) {
      if (this.jobHistoryCustomData[i].required) {
        this.requiredFields.push(this.jobHistoryCustomData[i].name);
      }
    }
  }
  checkClass(field) {
    this.checkIfAnswered();
    const isCheckBox =
      this.jobHistoryCustomData[this.isfixedDisplayIndex + 1] &&
      this.jobHistoryCustomData[this.isfixedDisplayIndex + 1].name ==
        field.name &&
      this.jobHistoryCustomData[this.isfixedDisplayIndex + 1].type == CHECK_BOX;
    if (
      field.type == FIXED_DISPLAY_TEXT ||
      (field.type == CHECK_BOX && isCheckBox)
    ) {
      if (this.$route.name === 'GuidedSignup') {
        return 'row col-sm-12 col-md-12 col-lg-12 ';
      }
      return 'text-left col-12';
    }
    return 'form-group col-12 col-sm-6 pt-2 ';
  }
  checkIfAnswered() {
    let count = 0;
    for (var i = 0; i < this.requiredFields.length; i++) {

      let  value =this.customFieldsModel[this.requiredFields[i]]
      if (value != null && value != 0) {
        if( value.toLowerCase()== "let me type" ){
          let val1=this.customFieldsModel[this.requiredFields[i]+"letMeType"]

            if (val1 != null && val1 != 0) {
            count +=1
          }
        }
        else{
          count += 1;
        }
      }
    }

    const disableCheck = count != this.requiredFields.length;
    const disable = this.minimumEntries >= 0 ? (this.isRequiredStep ? disableCheck : this.isRequiredStep) : disableCheck;
    this.$emit('update-button', disable);
  }


  onlyNumber(fieldDataType, $event) {
    //console.log($event.keyCode); //keyCodes value
    if (fieldDataType != 'int') {
      return true;
    }
    let keyCode = $event.keyCode ? $event.keyCode : $event.which;
    if (keyCode < 48 || keyCode > 57) {
      // 46 is dot
      $event.preventDefault();
    }
    return;
  }
  get jobHistoryCustomDataObj() {
    vxm.jobs.UserJobHistoryListResponse.jobHistoryMetaData.forEach(
      (item, idx) => {
        item.placeholder = 'Enter your ' + item.label;
      },
    );
    return vxm.jobs.UserJobHistoryListResponse.jobHistoryMetaData;
  }

  setSelectedJobRole(option = 'Pilot', initCall = false) {
    if (
      !vxm.jobs.userJobHistoryListResponseCopy.profiles ||
      !vxm.jobs.userJobHistoryListResponseCopy.profiles.length
    ) {
      return;
    }
    this.$emit(
      'update-role-help-text',
      option === 'Other'
        ? 'Resume is the only requirement to apply for a position'
        : '',
    );
    const availableFields = vxm.jobs.UserJobHistoryListResponse.profiles.find(
      (mapping) => mapping.name === option,
    );
    var existingResponse = vxm.jobs.UserJobHistoryListResponse;
    var newCustomFields = vxm.jobs.userJobHistoryListResponseCopy.jobHistoryMetaData.filter(
      (item) => {
        return availableFields && availableFields.fields.includes(item.id);
      },
    );
    if (!initCall) {
      Object.keys(this.customFieldsModel).forEach((key) => {
        if (key !== 'internalProfile') {
          this.customFieldsModel[key] = '';
        }
      });
      this.dropdownArr = [];
    }
    vxm.jobs.setUserJobHistoryListResponse({
      ...existingResponse,
      jobHistoryMetaData: newCustomFields,
    });
  }

  customDataInfo(customDataLabel) {
    if (customDataLabel == 'What is your job role?') return 'Job Role';
    return customDataLabel;
  }

  getArrayASCommaseparatedVal(customDesc) {
    if (customDesc.length > 0) {
      return customDesc.join(', ');
    }
    return customDesc;
  }

  getCustomDataValue(customData) {
    if (customData && !customData.value) {
      return '--';
    }
    if (typeof customData.value === 'boolean') {
      return customData.value ? 'Yes' : 'No';
    } else if (customData.type === DATE_PICKER && customData.value) {
      return this.$moment(
        vxm.utility.convertUTCToLocalTime(customData.value),
      ).format('DD-MMM-YYYY');
    } else if (customData.value === '1') {
      return 'Yes';
    } else if (customData.value === '0') {
      return 'NO';
    }
    return customData.value;
  }

  idDropdownSelected(val: string): boolean {
    return this.customFieldsModel[val] && this.customFieldsModel[val].length;
  }

  changeDropdownStatus(val: string) {
    if (
      this.customFieldsModel[val] &&
      !this.dropdownArr.includes(val) &&
      this.customFieldsModel[val].length > 0
    ) {
      this.dropdownArr = [...this.dropdownArr, val];
    }
  }
}
